export { EgLessonPlaceEntity } from './eg-lesson-place-entity';
export { EgLessonPlaceEntityList } from './eg-lesson-place-entity-list';
